module.exports = __webpack_public_path__ + "img/appLogo.39913e7c.png";